import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "19",
  viewBox: "0 0 21 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.2488 9.65281C12.6686 9.65281 14.6303 7.69111 14.6303 5.27123C14.6303 2.85135 12.6686 0.889648 10.2488 0.889648C7.82889 0.889648 5.86719 2.85135 5.86719 5.27123C5.86719 7.69111 7.82889 9.65281 10.2488 9.65281Z",
      stroke: "#AA1E2D",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1 18.4153V15.8457C1 14.0383 2.68771 12.5732 4.76972 12.5732H15.7303C17.8123 12.5732 19.5 14.0383 19.5 15.8457V18.4153",
      stroke: "#AA1E2D",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1)
  ])))
}
export default { render: render }